export enum Civility {
    Male = 'male',
    Female = 'female',
}
